import axiosRequest from './restapi';

export const getDashBoardStatistics = (role: string, token: string) =>
  axiosRequest(
    {
      method: 'get',
      url: `/${role.toLowerCase()}s/dashboard`,
    },
    token
  );

export default {
  getDashBoardStatistics,
};
